import { Fragment, useState } from 'react';

import _ from 'lodash';

import PropTypes from 'prop-types';

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import { FadeInAnimation } from '../../shared';

export const UTILITIES_CONST = Object.freeze({
    water: 'water',
    electricity: 'electricity',
    utilities: 'utilities',
});

const RoomTypeAmenities = (props) => {
    const { selectedRoomType, roomContentCMS } = props;
    const roomAmenities = _.get(selectedRoomType, 'amenities');
    const roomAmenityIcons = _.get(roomContentCMS, 'acf.room_amenity_icon');
    const featuredAmenities = _.get(selectedRoomType, 'featuredAmenities');
    const featuredAmenityImages = _.get(selectedRoomType, 'featuredAmenityImages');
    const defaultIconSrc = _.get(roomContentCMS, 'acf.default_amenity_icon.url');    

    const renderAmenities = () => {
        return _.map(roomAmenities, (amenity, index) => {
            return (
                <Fragment key={index}>
                    <FadeInAnimation>
                        <div className='room-type-amenities-amenity-container'>
                            {renderAmenityIcon(amenity)}
                            <span className='room-type-amenities-amenity-text'>{amenity}</span>
                        </div>
                        <hr className='room-type-amenities-hr' />
                    </FadeInAnimation>
                </Fragment>
            );
        });
    };

    const renderAmenityIcon = (amenityFromAPI) => {
        let returnDefault = true;
        let imgSrc = null;
        _.forEach(roomAmenityIcons, (icon) => {
            const iconSrc = _.get(icon, 'room_amenity_icon_image.url');
            const amenityId = _.get(icon, 'room_amenity_name');
            if (
                _.lowerCase(amenityId) === _.lowerCase(amenityFromAPI) ||
                (_.includes(_.lowerCase(amenityId), UTILITIES_CONST.water) &&
                    _.includes(_.lowerCase(amenityFromAPI), UTILITIES_CONST.water)) ||
                (_.includes(_.lowerCase(amenityId), UTILITIES_CONST.electricity) &&
                    _.includes(_.lowerCase(amenityFromAPI), UTILITIES_CONST.electricity)) ||
                (_.includes(_.lowerCase(amenityId), UTILITIES_CONST.utilities) &&
                    _.includes(_.lowerCase(amenityFromAPI), UTILITIES_CONST.utilities))
            ) {
                returnDefault = false;
                imgSrc = iconSrc;
            }

            return null;
        });
        if (returnDefault) {
            return <img src={defaultIconSrc} alt="homii-o" width={22} />;
        }
        return <img src={imgSrc} alt={amenityFromAPI} width={22} />;
    };

    const renderFeaturedAmenityImage = (i) => {
        return _.map(featuredAmenityImages, (imgSrc, index) => {
            if (index === i) {
                return <img className='room-type-amenities-img' width={200} height={135} src={imgSrc} alt="pan" key={index} />;
            }
            return null;
        });
    };

    const renderFeaturedAmenities = () => {
        return _.map(featuredAmenities, (amenity, index) => {
            const amenityDescription = _.get(amenity, 'description');
            if (index > 5) {
                return null;
            }
            return (
                <div className='main-grid-item main-grid-xl-4 main-grid-lg-4 main-grid-md-4 main-grid-sm-6 main-grid-xs-6' key={index}>
                    <div className='room-type-amenities-featured-amenity-container'>
                        <div className='room-type-amenities-featured-img-container'>
                            {renderFeaturedAmenityImage(index)}
                        </div>
                        <span className='room-type-amenities-featured-amenity-text'>{amenityDescription}</span>
                    </div>
                </div>
            );
        });
    };

    const renderMoreContent = () => {
        const [expanded, setExpanded] = useState(false);
        const [text, setText] = useState('See More +');

        const handleAccordionChange = (value) => () => {
            setExpanded(!value);
            setText(value ? 'See More +' : 'See Less -');
        };

        return (
            <div id="room-type-amenities" className='room-type-amenities-accordion-wrapper'>
                <Accordion expanded={expanded} onChange={handleAccordionChange(expanded)} className='room-type-amenities-accordion' id="room-type-amenities-accordion">
                    <AccordionSummary
                        className='room-type-amenities-accordion-summary'
                        aria-controls="panel1d-content"
                        id="ammenities-accordion-button"
                    >
                        <p className='room-type-amenities-accordion-text'>{text}</p>
                    </AccordionSummary>
                    <AccordionDetails className='room-type-amenities-accordion-details'>
                        <div className='room-type-amenities-accordion-content-container'>{renderAmenities()}</div>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    };

    return (
        <FadeInAnimation>
            <div id="homii-living-section">
                <h3 className='room-type-amenities-header3'>Room Amenities</h3>
                <p className='room-type-amenities-details'>
                    Live the HOMii lifestyle, wherever and however you choose to.
                </p>
                <div className='main-grid-container'>{renderFeaturedAmenities()}</div>
                {renderMoreContent()}
            </div>
        </FadeInAnimation>
    );
};

export default RoomTypeAmenities;

RoomTypeAmenities.propTypes = {
    selectedRoomType: PropTypes.object,
    roomContentCMS: PropTypes.object,
};

